import { Controller } from '@hotwired/stimulus';
import Swiper from 'swiper';

export default class extends Controller {
    static targets = ['dayText', 'slider']

    connect() {
        this.initializeSwiper();
    }

    disconnect() {
        if (this.swiper) {
            this.swiper.destroy();
        }
    }

    initializeSwiper() {
        const today = new Date().toLocaleDateString('lt-LT', { weekday: 'long' });

        const slides = this.element.querySelectorAll('.swiper-slide');
        const initialSlideIndex = Array.from(slides).findIndex(
            slide => slide.dataset.day.toLowerCase() === today.toLowerCase()
        );

        this.swiper = new Swiper(this.element.querySelector('.swiper'), {
            initialSlide: Math.max(0, initialSlideIndex),
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: true,
            touchEventsTarget: 'container',
            touchRatio: 1,
            touchAngle: 45,
            grabCursor: true,
            preventClicks: true,
            preventClicksPropagation: true,
            slideToClickedSlide: true,
            navigation: {
                nextEl: '[data-action="slider#next"]',
                prevEl: '[data-action="slider#prev"]',
            },
            on: {
                init: () => this.updateDayText(),
                slideChange: () => this.updateDayText(),
            }
        });

        this.updateDayText();
    }

    updateDayText() {
        if (!this.swiper) return;

        const slides = this.element.querySelectorAll('.swiper-slide');
        if (!slides.length) return;

        const currentSlide = slides[this.swiper.activeIndex];
        if (!currentSlide) return;

        const dayText = currentSlide.dataset.day;
        const dayTextElement = this.element.querySelector('.mobile-navigation [class*="timetable-cell-day"]');

        if (dayTextElement && dayText) {
            dayTextElement.textContent = dayText;
        }
    }

    prev(event) {
        event.preventDefault();
        if (this.swiper) {
            this.swiper.slidePrev();
        }
    }

    next(event) {
        event.preventDefault();
        if (this.swiper) {
            this.swiper.slideNext();
        }
    }
}
